import { render, staticRenderFns } from "./BaseUserActions.vue?vue&type=template&id=6dce25b3&"
import script from "./BaseUserActions.vue?vue&type=script&lang=js&"
export * from "./BaseUserActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports